// messageCenter/ticketLabels.js — how ticket values are shown: label keys of the fixed values, the ticket reference and
// local time. Pure functions; the values are those of TicketRepository (PHP).
import { str } from '../i18n/str.js';

export const STATUS_LABEL_KEYS = Object.freeze({
    new: 'MC_STATUS_NEW', in_progress: 'MC_STATUS_IN_PROGRESS', question: 'MC_STATUS_QUESTION',
    done: 'MC_STATUS_DONE', rejected: 'MC_STATUS_REJECTED',
});
export const KIND_LABEL_KEYS = Object.freeze({
    bug: 'MC_KIND_BUG', wish: 'MC_KIND_WISH', layout: 'MC_KIND_LAYOUT', question: 'MC_KIND_QUESTION',
});
export const PRIORITY_LABEL_KEYS = Object.freeze({
    normal: 'MC_PRIORITY_NORMAL', high: 'MC_PRIORITY_HIGH', urgent: 'MC_PRIORITY_URGENT',
});

/** Translated label of a fixed value; an unknown value shows itself. */
export function labelOf(labelKeys, value) {
    return labelKeys[value] ? str(labelKeys[value]) : String(value ?? '');
}

/** How a ticket is referenced in text and lists (decision D-16). */
export function ticketRef(ticketId) {
    return 'T#' + ticketId;
}

/** Unix timestamp (seconds, from the server) as local date and time; '' without a value. */
export function formatTime(ts, locale = document.documentElement.lang || 'de') {
    if (ts === null || ts === undefined) { return ''; }
    return new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'short' }).format(new Date(ts * 1000));
}
